/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAbsoluteSmoothScrollViewProps } from './absolute-smooth-scroll';

//import { render } from 'react-dom';
//@ts-ignore
import { Link, DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

export default (props: IAbsoluteSmoothScrollViewProps) => {

    const { 
        buttonText,
        smoothLink
    } = props;

    return (
        
        <>
            <Link activeClass="active" className="button pointy-button" to={smoothLink} spy={true} smooth={true} duration={1000}>{buttonText}</Link>
        </>
       
    );
};
